//储存 data数据
export function objData() {
    let data = {
        selatShow: false,//朝向高亮
        editFloorContentPopupShow: false, // 编辑楼层内容弹窗
        bConfirmPopupShow: false, //删除弹窗显示
        bSearchModalShow2: false, //产品选择弹窗显示
        oGoodsInfo: {
            arrWind: [],
        }, //产品选择弹窗接受数据
        bShowFloorPop: false, //增加楼层弹窗
        arrFloorType: [
            { id: 1, name: "楼层" },
            { id: 2, name: "地下室" },
        ], //楼层选择类型
        arrArea: [], //区域数据
        nCityId: 0, //城市id
        nAreaIndex: 0, //区域选择索引
        nFloorTypeIndex: 0, //楼层选择索引
        arrFloorArea: [], //楼层区域数据
        arrNum: [], //温度数组
        arrFw: [
            { value: "西北", open: false },
            { value: "北", open: false },
            { value: "东北", open: false },
            { value: "西", open: false },
            { value: "无/未知", open: false },
            { value: "东", open: false },
            { value: "西南", open: false },
            { value: "南", open: false },
            { value: "东南", open: false },
        ], //方位数据
        oPicker: {
            colorConfirm: "rgba(33, 51, 102, 1)",
        }, //picker 插件配置
        arrAnchor: [1], //温度初始值
        sDelTips: "", //删除提示
        nFloorId: "", //楼层id
        bDelFloor: false, //当前是否删除楼层
        bDelArea: false, //当前是否删除区域
        bBearing: false, // 方位弹窗显隐
        // 编辑楼层内容弹窗数据
        arrEditFloorContent: {
            activeIndex: 0,
            floor: [], // 楼层
            allTagContent: [], // 下面全部标签内容
        },
        nFindex: 0, //楼层索引
        nRindex: 0, //房间索引
        nWindex: 0, //商品索引
        arrShoppHeat: [], //地暖管
        arrHeatSink: [], //所有散热器
        arrWind:[],//所有风盘
        objTypeXuan: { name: "风盘", open: true, id: 1 },
        objInfo: {},//详情
    }
    return data
}